import styles from '../styles/components/specialOfferModal.module.css';
import { ReactComponent as StarIcon } from "../assets/star.svg";
import Modal from './Modal';
import { ReactComponent as MoneyIcon } from "../assets/money.svg";
import { StoreContext } from '..';
import { useContext } from 'react';
import Spinner from './Spinner';
import { Product } from '../models/product';
import { observer } from 'mobx-react-lite';
import WaitPaidInvoice from './WaitPaidInvoice';


interface ComponentProps {
    cancelModal: Function;
    product: Product;
    timeLeft: string;
    cancelSpecialOffer: Function;
};


function SpecialOfferModal({cancelModal, product, timeLeft, cancelSpecialOffer}: ComponentProps) {
    const {appStore} = useContext(StoreContext);

    const createInvoice = (product: Product, system: string) => {
        appStore.createInvoice((product as Product).id, system)
    };

    return <>
        {
            appStore.checkInvoiceId && <WaitPaidInvoice 
            invoiceId={appStore.checkInvoiceId} 
            cancel={(success: boolean | null = null) => {
                appStore.checkInvoiceId = null; 
                if (success === true) {
                    cancelSpecialOffer();
                    cancelModal();  // На всякий случай
                }
            }}/>
        }
        <Modal cancel={cancelModal}>
            <h1>Поздравляем!</h1>
            <span className={styles.description}>
                Вы выиграли <span className={styles.ok}>20% скидка на {product.product_value} промокоинов</span>.
                <br/>Успейте воспользоваться, предложение действует еще <span className={styles.destructive}>{timeLeft}!</span>
            </span>
            <div className={styles.offer}>
                <span className={styles.offer_count}>{product.product_value}<MoneyIcon/><span className={styles.discount}>-20%</span></span>
            </div>
            <div className={styles.pay}>
                <span className={styles.pay_header}>Воспользоваться</span>
                <div className={styles.pay_buttons}>
                    <button className={styles.pay_button} disabled={appStore.processInvoice.endsWith("robokassa")} onClick={() => createInvoice(product, "robokassa")}>
                        {appStore.processInvoice.endsWith("robokassa") ? <Spinner/> : <>{product?.price_rubs} руб<span>{product?.old_price} руб</span></>}
                    </button>
                    <button className={styles.star_pay_button} disabled={appStore.processInvoice.endsWith("telegram")} onClick={() => createInvoice(product, "telegram")}>
                        {appStore.processInvoice.endsWith("telegram") ? <Spinner/> : <><StarIcon/>{product?.price_stars}</>}
                    </button>
                </div>
                <div className={styles.cancel}>
                    <span onClick={() => cancelModal()}>Позже</span>
                </div>
            </div>
        </Modal>
    </>;
};

export default observer(SpecialOfferModal);